import styled, { useTheme } from 'styled-components';
import Icon from '../Icon';

const EditButtonStyled = styled.a`
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  background-color: ${(props) => {
    const { color, editButton } = props.theme;
    return color[editButton.backgroundColor];
  }};
  color: ${(props) => {
    const { color, editButton } = props.theme;
    return color[editButton.textColor];
  }};
  padding: 5px 15px 5px 5px;
  z-index: 999;
`;

const IconStyled = styled(Icon)`
  margin-right: 8px;
  width: 20px;
  height: 20px;
  path {
    fill: ${(props) => {
      const { color, editButton } = props.theme;
      return color[editButton.textColor];
    }};
  }
`;

const ButtonText = styled.span`
  display: inline;
  margin: 0;
  font-size: ${(props) => props.theme.editButton.fontSize};
`;

/**
 * @param {EditButtonProps} props
 * @returns {React.ReactElement} The rendered component
 */
const EditButton = ({ text, href, className, onHover }) => {
  const theme = useTheme();

  return (
    <EditButtonStyled
      href={href}
      className={className}
      onMouseEnter={() => onHover(true)}
      onMouseLeave={() => onHover(false)}
    >
      <IconStyled icon={theme.editButton.icon} />
      <ButtonText>{text}</ButtonText>
    </EditButtonStyled>
  );
};

export default EditButton;
